import React, { useEffect, useState } from 'react';
import { Row, Col, Button, Input,Card } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit ,faSave} from '@fortawesome/free-solid-svg-icons';
import DatePicker from 'react-datepicker';
import { FaCalendarAlt, FaEdit } from 'react-icons/fa';
import EditIcon from '../../../../../../../designUtils/OpsDashboard/AccountDetails/EditIcon.svg'
import UpdateAccountDetailsService from '../../../../../../../Service/OPSServices/AccountDetailsService/UpdateAccountDetailsService';
import reactRouterDom from 'react-router-dom';
import CustomModal from '../../../../../../Components/Modals/CustomModal';

function EditAccountDetailsCard(props) {
    const [addressModel, setAddressModel] = useState(false);
    const toggleModal = () => setAddressModel(!addressModel);
  
    const address = props.formData && props.formData.address ? props.formData.address : '';
  
    const words = address.trim().split(/\s+/);
    const isLong = words.length > 15;
    const shortText = isLong ? words.slice(0, 15).join(' ') + '...' : address;
    return (
      <>
        <Row>
          <Col md={9} className='mt-1'>
            <h5><b>Account Name :</b> {props.formData.name}</h5>
          </Col>
          <Col md={3}>
            <div className="d-flex justify-content-end mb-2">
              <Button
                onClick={() => props.setUpdateAccountDetails(true)}
                className="btn-background-color"
              >
                <img className='mb-1' src={EditIcon} alt="edit" /> Edit
              </Button>
            </div>
          </Col>
        </Row>
  
        <Row className="align-items-center mb-3">
          {/* Address */}
          <Col md={6} className='mt-1'>
            <div>
              <span>{shortText}</span>
              {isLong && (
                <span
                  onClick={toggleModal}
                  style={{
                    color: 'blue',
                    cursor: 'pointer',
                    marginLeft: '5px',
                    display: 'inline',
                    fontWeight: 500,
                  }}
                >
                  Read more
                </span>
              )}
            </div>
          </Col>
  
          <Col md={6}></Col>
  
          {/* <Col md={5} className="text-end mt-2">
            <h6><b>Account Type:</b></h6>
          </Col>
          <Col md={7} className='mt-1'>
            <span>{props.formData.Account_Types}</span>
          </Col> */}
  
         
  
         
          <Col md={5} className="text-end mt-2">
            <h6><b>Contact :</b></h6>
          </Col>
          <Col md={7} className="mt-1">
            <span>{props.formData.admin}</span>
          </Col>
          <Col md={5} className="text-end mt-2">
            <h6><b>Email :</b></h6>
          </Col>
          <Col md={7} className="mt-1">
            <span>{props.formData.email}</span>
          </Col>
          <Col md={5} className="text-end mt-2">
            <h6><b>Phone :</b></h6>
          </Col>
          <Col md={7} className="mt-1">
            <span>{props.formData.phone}</span>
          </Col>
          <Col md={5} className="text-end mt-2">
            <h6><b>Pricing Plan($) :</b></h6>
          </Col>
          <Col md={7} className="mt-1">
            <span>{props.formData.pricingPlan}</span>
          </Col>
          <Col md={5} className="text-end mt-2">
            <h6><b>Start Date :</b></h6>
          </Col>
          <Col md={7} className="mt-1">
            <span>{props.formData.startDate}</span>
          </Col>
        </Row>
  
        <CustomModal
          header="Full Address"
          isOpen={addressModel}
          toggle={toggleModal}
          size="md"
          className="curve-popup"
        >
          <p>{address}</p>
        </CustomModal>
        </>               
      

    );
};
function EditAccountDetailsCard1(props) {
    const [newFormData, setNewFormData] = useState(props.formData);
    const [formErrors, setFormErrors] = useState({});
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
      const { name, value } = e.target;
      setNewFormData({
        ...newFormData,
        [name]: value,
      });
    };

    const safelyFormatDate = (dateValue) => {
      if (!dateValue) return ''; 
      const d = new Date(dateValue);
      return isNaN(d.getTime()) ? '' : d.toISOString().split('T')[0];
    };
   
    const isFormValid = () => {
      const originalStart = safelyFormatDate(props.formData && props.formData.startDate);
      const newStart = safelyFormatDate(newFormData && newFormData.startDate);
    
      return (
        newFormData.address !== props.formData.address ||
        newFormData.pricingPlan !== props.formData.pricingPlan ||
        newFormData.admin !== props.formData.admin ||
        newFormData.email !== props.formData.email ||
        newFormData.phone !== props.formData.phone ||
        newFormData.name !== props.formData.name ||
        newStart !== originalStart
      );
    };
    
    
    const handleSubmitEditInfo = () => {
        if (!isFormValid()) return;
    
        const payloadToSubmit = { ...newFormData };

        if (payloadToSubmit.startDate) {
          const d = new Date(payloadToSubmit.startDate);
          if (!isNaN(d.getTime())) {
            payloadToSubmit.startDate = d.toISOString().split('T')[0];
          } else {
            payloadToSubmit.startDate = null; 
          }
        }
    
        setLoading(true);
        UpdateAccountDetailsService(props.token, newFormData).then((res) => {
          setLoading(false);
          if (res) {
           console.log(res)
            if(props.action ===true){
                props.setUpdateAccountDetails(false)
                props.setFormData(res.agenciesData)
                props.setRefreshDataFlag(prev => !prev)
            }
            else{
                props.handleCloseUpdateAccountDetailsPopup(res);
            }
            
          }
        });
      };

      const getSafeDatePickerDate = (dateValue) => {
        if (!dateValue) return null;
        const d = new Date(dateValue);
        return isNaN(d.getTime()) ? null : d;
      };
    
console.log(isFormValid)
    return (

        <>
        <Card className="p-3 card-of-problemarea">
            <Row>
            <Col md={3} className="text-end mt-3">
                    <h6><b>Account Name :</b></h6>
                </Col>
                <Col md={9} className="ps-0 mt-2">
                    <Input
                      name="name"
                      className='w-80'
                      value={newFormData.name || ''}
                      onChange={handleChange}
                    />
                </Col>

                <Col md={3} className="text-end mt-3">
                    <h6><b>Address :</b></h6>
                </Col>
                <Col md={9} className="ps-0 mt-2">
                    <Input
                        type="textarea"
                        name="address"
                        className="w-80"
                        rows="2"
                        value={newFormData.address || ''}
                        onChange={handleChange}
                        invalid={!!formErrors.address}
                    />
                    {formErrors.address && (
                        <div className="text-danger mt-1">{formErrors.address}</div>
                    )}
                </Col>
                
                  <Col md={3} className="text-end mt-4">
                    <h6><b>Contact :</b></h6>
                  </Col>
                  <Col md={9} className="ps-0 mt-3">
                    <Input
                      name="admin"
                      className='w-80'
                      value={newFormData.admin || ''}
                      onChange={handleChange}
                    />
                  </Col>
                  <Col md={3} className="text-end mt-4">
                    <h6><b>Email :</b></h6>
                  </Col>
                  <Col md={9} className="ps-0 mt-3">
                    <Input
                      name="email"
                      className='w-80'
                      value={newFormData.email || ''}
                      onChange={handleChange}
                    />
                  </Col>
                  <Col md={3} className="text-end mt-4">
                    <h6><b>Phone :</b></h6>
                  </Col>
                  <Col md={9} className="ps-0 mt-3">
                    <Input
                      name="phone"
                      className='w-80'
                      value={newFormData.phone || ''}
                      onChange={handleChange}
                    />
                  </Col>
                  <Col md={3} className="text-end mt-4">
                    <h6><b>Pricing Plan($) :</b></h6>
                  </Col>
                  <Col md={9} className="ps-0 mt-3">
                    <Input
                      name="pricingPlan"
                      className='w-80'
                      value={newFormData.pricingPlan || ''}
                      onChange={handleChange}
                    />
                  </Col>
                  <Col md={3} className="text-end mt-4">
                    <h6><b>Start Date :</b></h6>
                  </Col>
                  <Col md={9} className="ps-0 mt-3">
                    <div className="position-relative w-80">
                    <DatePicker
                        selected={getSafeDatePickerDate(newFormData.startDate)}
                        onChange={(date) =>
                          setNewFormData({ ...newFormData, startDate: date })
                        }
                        placeholderText="Select start date"
                        className="form-control"
                      />

                      <div className="calendar-icon-wrapper">
                        <FaCalendarAlt className="calendar-icon" />
                      </div>
                    </div>
                  </Col>
            </Row>
            <Row>
                <Col className='mb-2 mt-1'>
                    <div className="d-flex justify-content-end">
                    <Button
                      className="btn-background-color"
                      onClick={handleSubmitEditInfo}
                      disabled={!isFormValid() || loading}
                    >
                      {loading ? 'Saving...' : 'Save'}
                    </Button>
                    </div>
                </Col>
            </Row>
            </Card>
        </>
    )
}

export { EditAccountDetailsCard, EditAccountDetailsCard1 };

